<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15T13S1/images/cover.jpg?1688984851634" alt="This image is the cover for the book Lost Towns of the Hudson Valley, Lost"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Towns of the Hudson Valley, Lost
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Did you know a town can vanish? Discover the curious history of five towns nearly lost to history...</b></p><br/><p>This is the story of five towns located in New York's Hudson River Valley that met their demise as quickly as they were established. From the icehouses of Rockland Lake to the Ashokan Reservoir towns to the brick quarries of Roseton, only traces of these once vibrant settlements can now be found. Camp Shanks, one of World War II's most significant military compounds, was erected in 1942 but was quickly abandoned at the war's end. "Last Stop USA," as it was known, played host to over one million soldiers and welcomed patriotic visitors like Frank Sinatra and Shirley Temple. In this collection of images, local authors Wesley and Barbara Gottlock revive the spirits of these bygone communities and celebrate a lost way of life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wesley Gottlock, Barbara H. Gottlock
      </h2>
      
      <p class="authorDescription body article">Wesley Gottlock is a retired educator with a passion for the history of New York City and the Hudson Valley. He and his wife lecture on local history and coordinate tours to Bannerman Island in the Hudson River. This is their fifth book on New York history. Visit GottlockBooks.com to learn more. <p><p>Barbara Gottlock is a retired educator who now lectures on New York history and coordinates tours to Bannerman Island in the Hudson River with her husband. This is her fifth book authored with her husband devoted to capturing New York's past. Visit their website at GottlockBooks.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?530aa462